import { WORKSPACES } from '../constants'

export const isTakiacademy =
  localStorage.getItem('currentWorkspace') === WORKSPACES.TAKI.name

export const isOstedhy =
  localStorage.getItem('currentWorkspace') === WORKSPACES.OSTEDHY.name
